import React from 'react';
import {IntentTier, IntentTierLabels} from '../../../shared/scoredAccounts';
import {keys} from '../../../shared/util';
import {FilterControlWithNegate} from './FilterControlWithNegate';
import {FilterSelect} from './FilterSelect';

const intentTierOptions = keys(IntentTierLabels).map((value) => ({
  value,
  label: IntentTierLabels[value],
}));

export const IntentTierFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: IntentTier[];
  negate?: boolean;
  onChange: (value: IntentTier[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  const selectedIntentTierOptions = value.map((v) => ({
    value: v,
    label: IntentTierLabels[v],
  }));

  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          options={intentTierOptions}
          isMulti
          onChange={(values) => {
            onValueChange(values.map((v) => v.value) as IntentTier[]);
          }}
          value={selectedIntentTierOptions}
        />
      )}
    </FilterControlWithNegate>
  );
};
